export default __webpack_public_path__ + "static/media/folder-share-active.35be02b2.svg";